import {  FaCaretDown, FaEnvelope, FaPaperPlane} from "react-icons/fa";
import { Author1, BodyMessage,  ButtonIcon,  ButtonSendContainer, Chatlabel, ContainerChat, Message1, MessageBubble1, MessageContainer, MessageHeader, MessageIconContainer, MessageRow1, TextArea, TextAreaContainer, Time1 } from "./ChatStyles";
import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import { changeChatA, changeChatB, changeChatC, changeChatD } from "../../redux/openChat/openChatActions";

import TypingContainer from "./TypingContainer";

import axios from "axios";
import {chatArray, linkifyText} from "./functions";
import { use } from "react";



const socket = io( process.env.REACT_APP_BACKEND_URL, {
auth: {
       userId: localStorage.getItem("userId") 
       || crypto.randomUUID()
       }
       });
localStorage.setItem("userId", socket.auth.userId);


function ChatBot() {
const [chatbot, setchatbot] = useState(true);  
const [sending, setSending] = useState(false);
const [notrefresh, setnotrefresh] = useState(false)

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const chatbotAxios = async (message) => {
  setTyping(true);
  await delay(1000);
  setTyping(false)

  if (sending) return; // bloquea si ya se está enviando
  setSending(true);
  
  
  const messageNormalizeAndSplit = message.trim().toLowerCase().split(/\s+/);
  let matched = false;

  for (let v of chatArray) {
    for (let value of v.question) {
      if (messageNormalizeAndSplit.includes(value.toLowerCase())) {
        matched = true;

        setdisableB(false);
        dispatch(changeChatC({
          room: localStorage.getItem('userId'),
          author: 'ChatBot',
          message: v.answer,
          time: new Date().getHours() + ":" + new Date().getMinutes()
        }));

        if (openWithSocket) {
          dispatch(changeChatA(true));
          dispatch(changeChatB(true));
          dispatch(changeChatD(false));
        }

        break;
      }
    }
    if (matched) break;
  }

  if (!matched) {
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/chatbot`, { message });
      setdisableB(false);
      dispatch(changeChatC({
        room: localStorage.getItem('userId'),
        author: 'ChatBot',
        message: res.data.msg.answer,
        time: new Date().getHours() + ":" + new Date().getMinutes()
      }));

      if (openWithSocket) {
        dispatch(changeChatA(true));
        dispatch(changeChatB(true));
        dispatch(changeChatD(false));
      }
    } catch (err) {
      console.error(err);
    }
  }

  setSending(false); // desbloquear
};




  const handleSendMessageToBot = () => {
    const message = currentMessage.trim().toLowerCase(); // normalizamos

    if (message === 'bot') {
        chatbotAxios(currentMessage);
        setchatbot(true);
        return;
    }

    // 'help!' debería siempre poder activarse
    if (message === 'help!') {
        chatbotAxios(currentMessage);
        setchatbot(false);
        return;
    }

    // Solo enviar al bot si está activo
    if (chatbot) {
        chatbotAxios(currentMessage);
    }
  }
  
  const dispatch = useDispatch();
  const messagesEndRef = useRef(null);
  const userId = localStorage.getItem("userId");

  
  const [typing, setTyping] = useState(false);

  const [currentMessage, setCurrentMessage] = useState('');

  //const [openMessage, setOpenMessage] = useState(false);
   const openMessage = useSelector(state => state.chat.openMessage);
   
   //const [openMessageHeader, setOpenMessageHeader] = useState(false);
   const openMessageHeader = useSelector(state => state.chat.openMessageHeader);

   const messages = useSelector(state => state.chat.messages);
   //const [messages, setMessages] = useState([]);
   
   
   const openWithSocket = useSelector(state => state.chat.openWithSocket);
   //console.log(openWithSocket)
   //const [openWithSocket, setOpenWithSocket] = useState(true); 


   const [disableB, setdisableB] = useState(false)
   
  


    useEffect(() => {
    const timeoutId = setTimeout(() => {
      chatbotAxios('1234');
      
    }, 4000); 
    
    return () => clearTimeout(timeoutId);
  }, []);
   

   
   
   
   

  

  
  

  
  
  
  useEffect(() => {
     
    if (userId !== '' ) {
        socket.emit("join_room", userId);
           
     };    
     socket.on("receive_message", (data) => {
        
         setdisableB(false)
         dispatch(changeChatC(data));

         if(openWithSocket) {
            
            dispatch(changeChatA(true))
            
            
            dispatch(changeChatB(true));
           
             dispatch(changeChatD(false));

             

             return
            }
     });

  



    return () => {
      socket.off("receive_message");
      
    };   
  
    
       
      
  }, [openMessage, openWithSocket, openMessageHeader, socket])
  
  useEffect(() => {
  messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [messages]);

  

    const sendMessage = async () => {
     if (currentMessage !== '') {
        const messageData = {
            room:  userId,
            author: userId,
            message: currentMessage,
            time: new Date(Date.now()).getHours() +
            ":" +
            new Date(Date.now()).getMinutes() 
        };

      await socket.emit('send_message', messageData); 
      //setMessages((prev) => [...prev, messageData]);
      dispatch(changeChatC(messageData))
      setCurrentMessage('');
      handleSendMessageToBot();
     
     }
   }


   const handleopenChat =  () => {
     dispatch(changeChatA(!openMessage))
    }


// Typing
  useEffect(() => {
  socket.on("typing", () => {
     setdisableB(false)
    setTyping(true);
  });

  socket.on("stopTyping", () => {
    setTyping(false);
  });

  return () => {
    socket.off("typing");
    socket.off("stopTyping");
  };
}, []);


let typingTimeout;

const handleChange = (e) => {
  //setMessage(e.target.value);

   setCurrentMessage(e.target.value)

 
  
  socket.emit("typing", userId);

  clearTimeout(typingTimeout);

  typingTimeout = setTimeout(() => {
    socket.emit("stopTyping", userId);
  }, 2000);
};


// close Chat

useEffect(() => {
  socket.on('close_receive', () => {
    
      setdisableB(true);


    
  })

  return () => {
    socket.off('close_receive');
    
  }
}, [])


   



  
 

    return (
        <ContainerChat show={openMessage}>
            <MessageHeader show={openMessageHeader} onClick={handleopenChat}>
                <MessageIconContainer   show={openMessageHeader} >
           
           

                 <FaEnvelope/> 
                 
               
                 <Chatlabel>Chat</Chatlabel> 
                 
                 <FaCaretDown/>
                </MessageIconContainer >
            </MessageHeader>

            <MessageContainer open={openMessage}>
              
               <BodyMessage>
                  
                  <Message1>
                    
                       {messages.map((msg, index) => {
                         const isMine = msg.author === localStorage.getItem("userId");
                         
                         return (
                           <MessageRow1 key={index} isMine={isMine}>
                            
                                  <MessageBubble1 isMine={isMine}>
                                    
                                    <Author1 isMine={isMine}>
                                      {isMine ? "Me:" : msg.author === 'ChatBot' ? 'ChatBot 🤖' : 'Cristian 👤'}
                                    </Author1>
                      
                                    {linkifyText(msg.message)}
                      
                                    <Time1 colore={isMine}>{msg.time}</Time1>
                                  </MessageBubble1>
                                  
                                </MessageRow1>
                                
                              );
                            })}
                          
                            { typing && <TypingContainer/> }  
                              <div style={{height:'10px' , width:'100%'}}></div>
                              <div ref={messagesEndRef} />
                  </Message1>
                  
                 
               </BodyMessage>
                   

  


                <TextAreaContainer>

                <TextArea disabled={disableB} placeholder={disableB ? 'Cristian not conneted' : 'Please write here'} 
                   onChange={ handleChange}
                   value={currentMessage} 
                   onKeyDown={(e) => {
                    if(e.key === "Enter") {
                      e.preventDefault()
                      sendMessage()}}
                    } 
                ></TextArea>
                </TextAreaContainer>
            

               <ButtonSendContainer show={openMessage} style={{padding: '10px'}}>
                    <div>
                    <ButtonIcon onClick={sendMessage} >Send <FaPaperPlane/></ButtonIcon>
                    </div>
               </ButtonSendContainer>
                 
            </MessageContainer>
                 
 
          
        </ContainerChat>
    )
}


export default ChatBot;